import { KibsiClient } from './base';
const SERVICE = 'application';
export class DetectorKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, SERVICE);
    }
    list(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { ids, usage, hasEnhancer } = criteria ?? {};
        return this.get('/detectors', {
            ...(paginationRequest && {
                params: { continuationToken, pageSize, sort, ids: ids?.join(','), hasEnhancer, usage },
            }),
            ...requestConfig,
        });
    }
    createDetector(entity, requestConfig) {
        return this.post(`/models/${entity.modelId}/detectors`, entity, requestConfig);
    }
    getDetector(detectorId, requestConfig) {
        return this.get(`/detectors/${detectorId}`, requestConfig);
    }
    updateDetector(entity, requestConfig) {
        return this.put(`/detectors/${entity.id}`, entity, requestConfig);
    }
    getByIds(ids, includeModels, requestConfig) {
        return this.get('/detectors/byids', {
            ...requestConfig,
            params: { ids: ids.join(','), includeModels },
        });
    }
    deleteDetector(detectorId, requestConfig) {
        return this.del(`/detectors/${detectorId}`, requestConfig);
    }
    listDetectorEnhancers(detectorId, paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort } = paginationRequest || {};
        return this.get(`/detectors/${detectorId}/enhancers`, {
            ...requestConfig,
            params: { continuationToken, pageSize, sort },
        });
    }
    createDetectorEnhancer(detectorId, enhancerId, requestConfig) {
        return this.put(`/detectors/${detectorId}/enhancers/${enhancerId}`, undefined, requestConfig);
    }
    addDetectorEnhancers(detectorId, enhancerIds, requestConfig) {
        return this.put(`/detectors/${detectorId}/enhancers`, enhancerIds, requestConfig);
    }
    removeDetectorEnhancer(detectorId, enhancerId, requestConfig) {
        return this.del(`/detectors/${detectorId}/enhancers/${enhancerId}`, requestConfig);
    }
    listModels(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { ids } = criteria ?? {};
        return this.get('/models', {
            ...(paginationRequest && { params: { continuationToken, pageSize, sort, ids: ids?.join(',') } }),
            ...requestConfig,
        });
    }
    createModel(entity, requestConfig) {
        return this.post(`/models`, entity, requestConfig);
    }
    getModel(modelId, requestConfig) {
        return this.get(`/models/${modelId}`, requestConfig);
    }
    updateModel(entity, requestConfig) {
        return this.put(`/models/${entity.modelId}`, entity, requestConfig);
    }
    deleteModel(modelId, requestConfig) {
        return this.del(`/models/${modelId}`, requestConfig);
    }
    getDetectorsForModel(modelId, paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort } = paginationRequest || {};
        return this.get(`/models/${modelId}/detectors`, {
            ...requestConfig,
            params: { continuationToken, pageSize, sort },
        });
    }
    getModelUploadUrl(modelId, requestConfig) {
        return this.get(`/models/${modelId}/upload`, requestConfig);
    }
    downloadModelFile(modelId, redirect, requestConfig) {
        return this.get(`/models/${modelId}/download`, {
            params: {
                redirect,
            },
            ...requestConfig,
        });
    }
}
//# sourceMappingURL=detector.js.map